import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import texts from '../texts'

// PAYPER-1123: recuadro centrado con jerarquía - icono en caja redondeada
// (squircle), título corto en negrita y subtítulo en gris debajo.
const Error = ({
  title,
  text,
  height = 300,
  width = '100%',
}: {
  title?: string
  text?: string
  height?: number | string
  width?: number | string
}) => (
  <Box
    sx={{
      height,
      width,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      rowGap: 'var(--spacing-s)',
      p: 2,
      textAlign: 'center',
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '4em',
        height: '4em',
        borderRadius: 'var(--corners-l)',
        backgroundColor: 'error.light',
        color: 'error.main',
      }}
    >
      <ErrorOutlineRoundedIcon sx={{ fontSize: '1.75em' }} />
    </Box>
    <Typography
      sx={{
        fontWeight: 'var(--typography-fontWeight-semiBold)',
        fontSize: { xs: '1.25em', sm: '1.5em' },
      }}
    >
      {title ?? texts.genericError1}
    </Typography>
    {text && (
      <Typography
        sx={{
          color: 'neutral.dark',
          maxWidth: '22em',
          fontSize: { xs: '0.875em', sm: '1em' },
        }}
      >
        {text}
      </Typography>
    )}
  </Box>
)

export default Error
